import { createSlice } from "@reduxjs/toolkit";

// Extras are not guaranteed to be included on *every* response from the backend.
// Therefore, we cannot assume that the absence of an extra means we should delete it from our store.
// So, from the backend, each extra should include an 'unset' value rather than relying on the extra
// not being included in the response. That unset value should be the intialState here.

export const extrasSlice = createSlice({
  name: "extras",
  initialState: {
    curtailmentAlert: "none",
  },
  reducers: {
    handleExtras: (state, action) => {
      for (const key in state) {
        // @ts-ignore
        if (action.payload[key] && action.payload[key] !== state[key]) {
          // @ts-ignore
          state[key] = action.payload[key];
        }
      }
    },
  },
});

export const { handleExtras } = extrasSlice.actions;
export default extrasSlice.reducer;
